import styled from 'styled-components';

/**
 * Layout wrapper for the Pix mark.
 *
 * Purely structural: the mark carries its own brand colour (see `PixLogo`) and sits directly on
 * the checkout pane, like the SPEI wordmark.
 */
export const LogoWrap = styled.span`
  display: inline-flex;
  align-items: center;
  line-height: 0;
`;
